import {useEffect} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {useLogoutMutation} from '../../../redux/api/services/auth'
import {useSelector} from 'react-redux'
import {RootState} from '../../../redux/store'

export function Logout() {
  const [logout] = useLogoutMutation()
  const infoState = useSelector((state: RootState) => state.info)
  useEffect(() => {
    logout({info: infoState}).finally(() => document.location.reload())
  }, [logout])

  return (
    <Routes>
      <Route path='*' element={<Navigate to='/auth' />} />
    </Routes>
  )
}
